import axios from 'axios';

// Detecção automática do ambiente
const getApiBaseUrl = () => {
  const isDevelopment = process.env.NODE_ENV === 'development' ||
                       window.location.hostname === 'localhost' ||
                       window.location.hostname === '127.0.0.1' ||
                       window.location.port === '3002';

  const baseUrl = isDevelopment
    ? (process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:8080')
    : (process.env.REACT_APP_API_URL_PROD || 'https://backend.mvpdelivery.com');

  return `${baseUrl}/api`;
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface AddressSuggestion {
  place_id: string;
  description: string;
  main_text: string;
  secondary_text: string;
}

export interface AutocompleteResponse {
  suggestions: AddressSuggestion[];
  query: string;
  success: boolean;
}

export interface PlaceDetailsResponse {
  formatted_address: string;
  latitude: number;
  longitude: number;
  place_id: string;
  success: boolean;
}

export const geocodingAPI = {
  getAutocomplete: async (query: string, session_token?: string): Promise<AutocompleteResponse> => {
    const response = await api.post('/geocoding/autocomplete', { query, session_token });
    return response.data;
  },
  getPlaceDetails: async (place_id: string, session_token?: string): Promise<PlaceDetailsResponse> => {
    const response = await api.post('/geocoding/place-details', { place_id, session_token });
    return response.data;
  },
};
